<template>
  <v-app>
    <!-- 読込中 -->
    <v-skeleton-loader
      v-show="progress"
      width="100%"
      max-height="300"
      type="card"
    ></v-skeleton-loader>

    <!-- 店舗情報 -->
    <v-container class="pa-0" v-if="!progress && about != null">
      <div>
        <v-img max-height="300px" :src="about.imgUrl"></v-img>
      </div>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col
            ><span class="text-h4">{{ about.name }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col>
            <span class="pre-wrap text-body-1" v-text="about.description" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <a :href="`${about.url}`">{{ about.url }}</a>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col><span class="text-h6">営業時間</span></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            ><span class="pre-wrap text-body-1" v-text="about.workTime"></span
          ></v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col
            ><span class="text-h6">お支払い方法 (モバイルオーダー)</span></v-col
          >
        </v-row>
        <v-row no-gutters>
          <v-col
            ><span class="text-body-1">{{ about.wayOfPay }}</span></v-col
          >
        </v-row>
      </v-container>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col><span class="text-h6">住所</span></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col> 〒{{ about.postalCode }}</v-col>
        </v-row>
        <v-row no-gutters>
          <v-col> {{ about.address }}</v-col>
        </v-row>

        <!-- 地図 -->
        <v-row v-show="googleMapSrc">
          <v-col class="googlemap">
            <iframe
              :src="googleMapSrc"
              frameborder="0"
              style="border: 0"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            />
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col><span class="text-h6">お問い合わせ</span></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <a :href="`tel:${about.phone}`">{{ about.phone }}</a>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pa-4" v-show="about.law">
        <v-row>
          <v-col><span class="text-h6">特定商取引法に基づく表記</span></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <router-link :to="{ name: 'Law' }"
              >こちらをご参照ください</router-link
            >
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pa-4">
        <v-row>
          <v-col align="center">
            <v-btn
              large
              tile
              text
              outlined
              :to="{ name: 'MenuList' }"
              style="width: 100%"
              >メニューを見る</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    googleMapSrc: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "店舗情報";
    this.$store.state.cart = false;
  },
  computed: {
    ...mapGetters(["progress", "about"]),
  },
  watch: {
    about: function () {
      this.bindData();
    },
  },
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();
    try {
      await this.fetchData();
    } catch (e) {
      console.error(e);
    } finally {
      this.hideProgress();
    }
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchAbout"]),
    fetchData: async function () {
      return this.fetchAbout();
    },
    bindData: async function () {
      // 地図
      if (this.about) {
        const address = this.about.address;
        this.googleMapSrc = this.createGoogleMapSrc(address);
        console.log(this.googleMapSrc);
      }
    },
    createGoogleMapSrc: function (address) {
      const URL_BASE = "https://maps.google.co.jp/maps?output=embed&q=";
      if (address) {
        return `${URL_BASE}${address}`;
      }
      return `${URL_BASE}`;
    },
  },
};
</script>

<style>
@import "../css/common.css";
</style>
<style scoped>
.googlemap {
  height: 300px;
}
.googlemap iframe {
  width: 100%;
  height: 100%;
}
</style>
